import './App.css';
import HomeScreen from './screens/HomeScreen';
import AuthorizationProvider from './context/AuthorizationContext';
import Snow from './components/Snow';

function App() {
  const now = new Date();
  const month = now.getMonth() + 1; // 1-12
  const day = now.getDate(); // 1-31
  const isXmas = (month === 12 && day >= 1) || (month === 1 && day <= 5);

  return (
    <div className='App'>
      <AuthorizationProvider>
        {isXmas && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 1,
              pointerEvents: 'none',
            }}
          >
            <Snow />
          </div>
        )}
        <HomeScreen />
      </AuthorizationProvider>
    </div>
  );
}

export default App;
